export type PixelCrop = { x: number; y: number; width: number; height: number };

export async function createCroppedAvatarBlob(source: string, crop: PixelCrop): Promise<Blob> {
  const image = await loadImageForCrop(source);
  const canvas = document.createElement("canvas");
  canvas.width = 512;
  canvas.height = 512;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("画像の処理を開始できませんでした。");
  context.fillStyle = "#f3f5f8";
  context.fillRect(0, 0, 512, 512);
  context.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, 512, 512);
  return await new Promise<Blob>((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("画像の作成に失敗しました。")), "image/jpeg", 0.88));
}

export function loadImageForCrop(source: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("選択した画像を読み込めませんでした。"));
    image.src = source;
  });
}
